// Reconciles the persisted `isActiveUser` flag with the server on every
// client boot, before any page reads it. This guards against a stale
// localStorage payload telling the UI a paying subscriber is inactive when
// the server says otherwise — the source of the "video won't play" bug.
//
// Only runs client-side because Pinia's persisted state itself is
// localStorage-backed; on the server there is nothing to reconcile.
export default defineNuxtPlugin(() => {
  // On the recovery route the user is deliberately wiping local state — don't
  // fire auth calls against a token we're about to clear.
  if (window.location.pathname.includes("limpar-cache")) return;

  const jwt = jwtStore();
  const user = userStore();

  if (!jwt.jwt || !user.isLoggedIn) return;

  // Fire-and-forget on purpose: reconciliation must never block the app's
  // mount/hydration. A slow, hung, or failing auth call should degrade to a
  // deferred check, not a frozen boot. `getActiveUser` swallows its own
  // errors (and logs out on a dead session), so there is nothing to await.
  void user.getActiveUser();
});
